import { defineModule } from './noodl-sdk'
import { LexicalEditorNode } from './LexicalEditor'

defineModule({
    reactNodes: [
    	LexicalEditorNode
    ],
}); 